import { Favorite, SvgIconComponent } from "@mui/icons-material"
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder"
import { useMediaQuery } from "@mui/material"
import Button from "@mui/material/Button"
import { Theme } from "@mui/material/styles"
import { makeStyles } from "tss-react/mui-compat"
import { MouseEventHandler } from "react"

const useStyles = makeStyles()(
  (theme) => ({
    button: {
      minWidth: "initial",
      width: 40,
      height: 38,
      backgroundColor: theme.palette.gray.lightest,
      borderRadius: 10,

      "&:hover, &:active": {
        backgroundColor: theme.palette.gray.main,
      },

      [theme.breakpoints.up("sm")]: {
        width: "auto",
        height: "auto",
      },
    },
    label: {
      fontSize: 16,
      textTransform: "initial",
    },
    startIcon: {
      // reset space around the icon
      marginLeft: 0,
      marginRight: 0,

      [theme.breakpoints.up("sm")]: {
        // set back MUI space around the icon
        marginLeft: -4,
        marginRight: 8,
      },

      // needed to set custom icon size
      "& > *:first-child": {
        fontSize: 24,
      },
    },
  })
)

interface FavoriteButton {
  isFavorite: boolean
  name: string
  onClick: MouseEventHandler<HTMLButtonElement>
}

export const FavoriteButton = (props: FavoriteButton) => {
  const { isFavorite, onClick, name } = props
  const { classes } = useStyles()

  const isDesktop = useMediaQuery<Theme>((theme) => theme.breakpoints.up("sm"))
  const buttonText = isFavorite ? "Added to favorites" : "Add to favorites"
  const StartIcon: SvgIconComponent = isFavorite ? Favorite : FavoriteBorderIcon

  return (
    <Button
      color="inherit"
      variant="contained"
      classes={{ root: classes.button, startIcon: classes.startIcon }}
      startIcon={<StartIcon color="primary" fontSize="inherit" />}
      onClick={onClick}
      aria-label={`${isFavorite ? "Unfavorite" : "Favorite"} ${name}`}>
      <span className={classes.label}>{isDesktop && buttonText}</span>
    </Button>
  )
}
